import { render, staticRenderFns } from "./LegacyBundleImportForm.vue?vue&type=template&id=7309885c&scoped=true"
import script from "./LegacyBundleImportForm.vue?vue&type=script&lang=js"
export * from "./LegacyBundleImportForm.vue?vue&type=script&lang=js"
import style0 from "./LegacyBundleImportForm.vue?vue&type=style&index=0&id=7309885c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7309885c",
  null
  
)

export default component.exports